import React, { useState } from 'react';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FiLock, FiUser, FiCheckCircle, FiAlertCircle } from 'react-icons/fi';
import api from '../services/api';
import { encryptPassword } from '../utils/auth';

const ResetPassword = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        cpf: '',
        matricula: '',
        new_password: '',
        confirm_password: ''
    });
    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState({ type: '', msg: '' });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (formData.new_password !== formData.confirm_password) {
            setStatus({ type: 'danger', msg: 'As senhas não coincidem.' });
            return;
        }

        if (!token) {
            setStatus({ type: 'danger', msg: 'Token de redefinição inválido ou ausente.' });
            return;
        }

        setLoading(true);
        setStatus({ type: '', msg: '' });

        try {
            // Usando o token no header Authorization
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            await api.post('/auth/reset', {
                cpf: formData.cpf,
                matricula: formData.matricula,
                new_password: encryptPassword(formData.new_password)
            }, config);

            setStatus({ type: 'success', msg: 'Senha redefinida com sucesso! Redirecionando para login...' });
            
            setTimeout(() => {
                navigate('/login');
            }, 3000);
        } catch (err) {
            console.error(err);
            const errorMsg = err.response?.data?.msg || 'Erro ao redefinir senha. Verifique seus dados.';
            setStatus({ type: 'danger', msg: errorMsg });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="d-flex align-items-center justify-content-center min-vh-100" style={{ backgroundColor: '#F5F7FA' }}>
            <Container style={{ maxWidth: '500px' }}>
                <div className="text-center mb-4">
                     <img src="/Logo_titulo-nbg.png" alt="Confirma AI" style={{ width: '250px' }} />
                </div>
                
                <Card className="shadow-sm border-0">
                    <Card.Body className="p-4">
                        <h4 className="text-center fw-bold mb-4" style={{ fontFamily: 'Nunito, sans-serif', color: '#00BFA5' }}>
                            Redefinição de Senha
                        </h4>

                        {status.msg && <Alert variant={status.type} className="mb-4">{status.msg}</Alert>}

                        {!token ? (
                            <Alert variant="warning">
                                <FiAlertCircle className="me-2"/>
                                Token inválido. Por favor, solicite uma nova redefinição.
                            </Alert>
                        ) : (
                            <Form onSubmit={handleSubmit}>
                                <Alert variant="info" className="small mb-4">
                                    Por segurança, confirme seus dados pessoais antes de alterar a senha.
                                </Alert>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-muted fw-bold">CPF</Form.Label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0"><FiUser className="text-muted"/></span>
                                        <Form.Control
                                            type="text"
                                            name="cpf"
                                            placeholder="Apenas números ou com pontuação"
                                            value={formData.cpf}
                                            onChange={handleChange}
                                            required
                                            className="border-start-0 ps-0"
                                        />
                                    </div>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-muted fw-bold">Matrícula</Form.Label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0"><FiUser className="text-muted"/></span>
                                        <Form.Control
                                            type="text"
                                            name="matricula"
                                            placeholder="Sua matrícula"
                                            value={formData.matricula}
                                            onChange={handleChange}
                                            required
                                            className="border-start-0 ps-0"
                                        />
                                    </div>
                                </Form.Group>

                                <hr className="my-4" />

                                <Form.Group className="mb-3">
                                    <Form.Label className="small text-muted fw-bold">Nova Senha</Form.Label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0"><FiLock className="text-muted"/></span>
                                        <Form.Control
                                            type="password"
                                            name="new_password"
                                            placeholder="Nova senha segura"
                                            value={formData.new_password}
                                            onChange={handleChange}
                                            required
                                            className="border-start-0 ps-0"
                                        />
                                    </div>
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label className="small text-muted fw-bold">Confirmar Nova Senha</Form.Label>
                                    <div className="input-group">
                                        <span className="input-group-text bg-white border-end-0"><FiLock className="text-muted"/></span>
                                        <Form.Control
                                            type="password"
                                            name="confirm_password"
                                            placeholder="Repita a senha"
                                            value={formData.confirm_password}
                                            onChange={handleChange}
                                            required
                                            className="border-start-0 ps-0"
                                        />
                                    </div>
                                </Form.Group>

                                <Button 
                                    variant="primary" 
                                    type="submit" 
                                    className="w-100 py-2 fw-bold" 
                                    disabled={loading}
                                    style={{ backgroundColor: '#00BFA5', borderColor: '#00BFA5' }}
                                >
                                    {loading ? <Spinner size="sm" animation="border" /> : <><FiCheckCircle className="me-2"/> Redefinir Senha</>}
                                </Button>
                            </Form>
                        )}
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
};

export default ResetPassword;
